import React, { useEffect, useState } from "react";

import useGrid from "../../hooks/grid/useGrid";
import {
  IconPack,
  DynamicCardContent,
  DynamicTestimonialContent,
  DynamicCardGridContent,
  DynamicButtonContent
} from "../../models/app-data-model";
import DynamicButton from "../dynamic-button/dynamic-button";
import DynamicCard from "../dynamic-card/dynamic-card";
import TestimonialCard from "../testimonial-card/testimonial-card";
import "./dynamic-card-grid.scss";

export type DynamicCardGridProps = {
  content: DynamicCardGridContent;
  cardWidth: number;
  condensedGrid: boolean;
  iconPack: IconPack[];
};

const DynamicCardGrid: React.FC<DynamicCardGridProps> = ({ content, cardWidth, condensedGrid, iconPack }: DynamicCardGridProps) => {
  const [isShowAllToggled, toggleShowAll] = useState(condensedGrid);
  const [cardCount, setCardCount] = useState<number>();

  //get the populated array prop from the object
  const cards = Object?.values(content)
    .filter((cardTypeArray) => typeof cardTypeArray == "object" && cardTypeArray?.length > 0)
    .shift() as DynamicCardContent[];

  useEffect(() => {
    //if condensed grid with more than 3 cards display show all button until clicked
    setCardCount(isShowAllToggled && cards?.length > 3 ? 3 : cards?.length);
  }, [cards?.length, isShowAllToggled]);

  //useGrid array for condensed or full card count
  const cardRowArray = useGrid(cards?.slice(0, cardCount), cardWidth);

  

  const cardRowRendering = cardRowArray?.map((cardRow, rowIndex) => {
    const cardRowClass = `card-row${rowIndex === 0 ? " first-row" : ""}${rowIndex + 1 === cardRowArray.length ? " last-row" : ""}${
      cardWidth === 1 ? " full-width" : ""
    }`;
    return (
      <>
        <div data-testid={`cardrow${rowIndex}`} key={rowIndex} className={cardRowClass}>
          {cardRow.items.map((card, cardIndex) =>
            content.card_type != "Testimonial" ? (
              <DynamicCard
                key={cardIndex}
                card_width={cardWidth}
                card_type={content.card_type}
                card_style={content.card_content_style}
                card_content={card as DynamicCardContent}
                card_content_size={content.card_content_size}
                iconPack={iconPack}
              />
            ) : (
              <TestimonialCard
                key={cardIndex}
                card_width={cardWidth}
                card_style={content.card_content_style}
                card_content={card as DynamicTestimonialContent}
                card_content_size={content.card_content_size}
              />
            )
          )}
        </div>
      </>
    );
  });

  const dynamicButtonContent: DynamicButtonContent = {
    text: "Show All",
    icon: "caret_down",
    settings: {
      button_type: "tertiary",
      color: "default",
      size: "small",
      button_id: "showAll"
    }
  };

  return (
    <>
      <div className="dynamic-card-grid" data-testid="dynamic-card-grid">
        {cardRowRendering}
        {isShowAllToggled && (
          <div className="grid-bottom-button">
            <DynamicButton
              content={dynamicButtonContent}
              iconPack={iconPack}
              cssClasses="show-more"
              {...{
                onClick: () => {
                  toggleShowAll(false);
                }
              }} // override the link funtionality for video modal: it should always open the video modal
            />
          </div>
        )}
      </div>
    </>
  );
};

export default DynamicCardGrid;
